import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ProductCard } from "@/components/ProductCard";
import { Reveal } from "@/components/Reveal";

export default function BestSellersPage() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.products({ bestseller: true, limit: 24 }).then(setProducts).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <main data-testid="best-sellers-page" className="mx-auto max-w-7xl px-4 py-12 sm:px-6 sm:py-16 lg:px-8">
      <Reveal>
        <p className="mb-3 text-xs font-semibold uppercase tracking-[0.22em] text-neutral-400">Proven Favourites</p>
        <h1 className="font-heading text-3xl font-bold tracking-tight text-neutral-900 sm:text-4xl lg:text-5xl">Best Sellers</h1>
        <p className="mt-3 max-w-xl text-sm leading-relaxed text-neutral-500 sm:text-base">
          The most reordered, most gifted, most reviewed products in the store — rated 4.7 and above by everyday shoppers.
        </p>
      </Reveal>

      {loading ? (
        <div className="mt-10 grid grid-cols-2 gap-6 lg:grid-cols-4">
          {[...Array(8)].map((_, i) => (
            <div key={i} className="aspect-[4/5] animate-pulse rounded-xl bg-neutral-200/70" />
          ))}
        </div>
      ) : (
        <div className="mt-10 grid grid-cols-2 gap-x-5 gap-y-10 lg:grid-cols-4">
          {products.map((p, i) => (
            <Reveal key={p.slug} delay={(i % 4) * 0.05} y={20}>
              <ProductCard product={p} />
            </Reveal>
          ))}
        </div>
      )}
    </main>
  );
}
